import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './UserProfile.css';
// import DistributorSidebar from '../components/Sidebar/DistributorSidebar';
import Sidebar from '../components/Sidebar/Sidebar';
// import PharmacistSidebar from '../components/Sidebar/PharmacySidebar';
import Dashboard from '../components/UserComponents/Dashboard/Dashboard';
import Inventory from '../components/UserComponents/Inventory/Inventory'; 
import Analytics from '../components/UserComponents/Analytics/Analytics';
import Donations from '../components/UserComponents/Donations/Donations';
import Drugs from '../components/UserComponents/Drugs/Drugs';
import DrugConsumptions from '../components/UserComponents/DrugConsumptions/DrugCon';
import Marketplace from '../components/UserComponents/Marketplace/Marketplace.jsx';
import Orders from '../components/UserComponents/Orders/Orders';
import Vendors from '../components/UserComponents/Vendors/Vendors';
import Reports from '../components/UserComponents/Reports/Reports';
import Notifications from '../components/UserComponents/Notifications/Notifications';
import TopBar from '../components/TopBar/TopBar'; 
// import DistributorTopBar from '../components/TopBar/TopBarDistributors'; 
import Wards from '../components/UserComponents/Wards/Wards';
// import WardSidebar from '../components/Sidebar/WardSidebar';
// import TopBarWards from '../components/TopBar/TopBarWards';
import Homepage from '../components/Homepage/Homepage';
import IndentRequest from '../components/UserComponents/IndentRequest/IndentRequest';
import SpecialIndentRequest from '../components/UserComponents/IndentRequest/SpecialIndentRequest';
import OrderRequests from '../components/OrderRequests/OrderRequests.jsx';

const UserProfile = () => {
  const location = useLocation();
  const { role } = location.state || {}; 
  const [activeContent, setActiveContent] = useState('homepage'); 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  

  const renderSidebar = () => {
    switch (role) {
      default:
        return <Sidebar onLinkClick={setActiveContent} role={role}/>;
    }
  };
  
  const renderContent = () => {
    switch (activeContent) {
      case 'homepage':
        return <Homepage/>;
      case 'dashboard':
        return <Dashboard role={role} />;
      case 'inventory':
        return <Inventory role={role} />;  
      case 'drugs':
        return <Drugs />;
      case 'vendors':
        return <Vendors />;
      case 'donations':
        return <Donations />;
      case 'drugConsumption':
        return <DrugConsumptions role = {role}/>;
      case 'orders':
        return <Orders role={role}/>;
      case 'analytics':
        return <Analytics />;
      case 'reports':
        return <Reports />;
      case 'notifications':
        return <Notifications  role={role}/>;
      case 'marketplace':
        return <Marketplace />;
      case 'wards':
        return <Wards/>;
      case 'SindentReq':
        return <SpecialIndentRequest/>;
      case 'indentReq':
        return <IndentRequest/>;
      case 'orderreq':
        return <OrderRequests/>;
      default:
        return null;
    }
  };

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  
  // const renderTopBar = () => {
  //   if (role === 'pharmacist') {
  //     return <TopBar />;  
  //   } else if (role === 'distributor') {
  //     return <DistributorTopBar />; 
  //   } else if(role === 'ward'){
  //     return <TopBarWards/>;
  //   }else {
  //     return <div>No TopBar available for this role.</div>; 
  //   }
  // };

  return (
    <div className="user-profile-container">
      
      <div className={`overlay-block ${isSidebarOpen ? 'visible' : ''}`} onClick={handleSidebarToggle}></div>
      <div className="overlay">
        <div className="content-wrapper">
          {renderSidebar()} 
          <div className="main-content-wrapper">
            {/* {renderTopBar()}  */} <TopBar role={role}/>
            <div className="main-content">
              {renderContent()}  
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
